function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-170421ba\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vux-loader/src/after-less-loader.js!less-loader?{'modifyVars':{'header-background-color':'#459FFB','icon-success-color':'#ffffff','header-arrow-color':'#ffffff','header-text-color':'#ffffff','button-tab-border-color':'#459FFB','button-tab-active-background-color':'#459FFB','button-tab-default-text-color':'#459FFB','button-tab-active-text-color':'#ffffff','tab-text-active-color':'#459FFB','tab-bar-active-color':'#459FFB','tabbar-text-active-color':'#459FFB','timeline-item-bg-color':'#45a8fb','datetime-header-item-font-color':'#45a8fb','dialog-width':'95%','dialog-max-width':'95%'},'sourceMap':true}!../../../../node_modules/vux-loader/src/style-loader.js!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./leaveApply.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vux-loader/src/script-loader.js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./leaveApply.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-170421ba\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../node_modules/vux-loader/src/template-loader.js!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./leaveApply.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-170421ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/launch/attendance/leaveApply.vue
// module id = rS/7
// module chunks = 1